import React from 'react'
import { motion } from 'framer-motion'
import { Play } from 'lucide-react'
function ToolsComponent() {
  return (
    <div className='card p-20 m-10'>
        <div>
            Function for LLM Models<button className='center'><span className='text-primary text-xs ml-10 hover'>See example and learn more</span></button>
        </div>
        <div className='text-sm'>
        Connect external tools or APIs that your language model can call during conversations.
        This allows the LLM to retrieve real-time data, perform calculations, or trigger actions dynamically.
        </div>
        {/* Choose function */}
        <div className='mt-20'>
            <div className='mb-10'>
                Choose function
            </div>
            <div className='flex gap-3'>
            <select id="llm-model" className="agent-form-input flex-1 " style={{height: 'auto'}} >
                    <option value="gpt-4o">GPT-4o</option>
                    <option value="gpt-3.5">GPT-3.5</option>
                    <option value="gemini">Gemini</option>
                </select>
                <motion.button
                 whileHover={{
                scale: 1.02
                 }}
                 whileTap={{
                    scale: 0.98
                 }}
                    className="submit-btn-style " style={{ height: '45px', width: 'auto', padding: '0 20px' }}>
                    Add Function
                </motion.button>
            </div>
        </div>
    </div>
  )
}

export default ToolsComponent